import { selector, selectorFamily } from 'recoil';
import { TicketStatus } from '../../entities/Ticket';
import ticketListState from '../ticketListState';


export const unAssignedTicketsState = selector({
  key: 'unAssignedTicketListState',
  get: ({ get }) => {
    const tickets = get(ticketListState);

    return tickets?.filter((ticket) => !ticket.agent && ticket.ticketStatus != TicketStatus.closed)
  }
})

export const notClosedTicketsState = selector({
  key: 'notClosedTicketListState',
  get: ({ get }) => {
    const tickets = get(ticketListState);
    return tickets?.filter((ticket) => ticket?.ticketStatus != TicketStatus.closed)
  }
})

export const closedTicketsState = selector({
  key: 'closedTicketListState',
  get: ({ get }) => {
    const tickets = get(ticketListState);
    return tickets?.filter((ticket) => ticket?.ticketStatus == TicketStatus.closed)
  }
})

export const myTicketsState = selectorFamily({
  key: 'myTicketsState',
  get: (agentId) => ({ get }) => {
    if (!agentId) return []
    const tickets = get(ticketListState)
    return tickets?.filter((ticket) => ticket.agent == agentId && ticket.ticketStatus != TicketStatus.closed)
  }
})

export const ticketState = selectorFamily({
  key: 'ticketState',
  get: (ticketId) => ({ get }) => {
    const tickets = get(ticketListState)
    return tickets?.find((ticket) => ticket.id == ticketId)
  }
})

export const ticketsByEmailState = selectorFamily({
  key: 'ticketsByEmailState',
  get: (email) => ({ get }) => {
    const tickets = get(ticketListState)
    return tickets?.filter((ticket) => ticket.emailFrom == email)
  }
})

